import { render, staticRenderFns } from "./PblmWarranty.vue?vue&type=template&id=1885a72e&"
import script from "./PblmWarranty.vue?vue&type=script&lang=js&"
export * from "./PblmWarranty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports